class InputMessenger {
    constructor(el) {
        this.el = el;
        this.selected = this.el.querySelector(".js-input-messenger-selected");
        this.img = this.el.querySelector(".js-input-messenger-selected-img");
        this.items = this.el.querySelectorAll(".js-input-messenger-item");
        this.inputName = this.el.querySelector(".js-input-messenger-input-name");
        this.initEvents();
    }

    initEvents() {
        this.selected.addEventListener("click", () => {
            this.el.classList.toggle("opened");
        });
        this.items.forEach(item => {
            item.addEventListener("click", () => {
                this.el.classList.remove("opened");
                this.img.src = item.querySelector(".js-input-messenger-item-img").src;
                this.inputName.value = item.querySelector(".js-input-messenger-item-name").innerText;
                this.el.classList.add("filled");
            });
        });
        document.addEventListener("click", (e) => {
            if (!e.target.classList.contains("js-input-messenger-selected")
            && !e.target.closest(".js-input-messenger-selected")
            && !e.target.closest(".js-input-messenger-dropdown")
            ) {
                this.el.classList.remove("opened");
            }
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-input-messenger")
        .forEach(input => new InputMessenger(input));
});
